import React from 'react';

const PortfolioSelector = ({ portfolios, value, onChange, loading }) => {
  if (loading) {
    return <div className="selector-loading">Loading portfolios…</div>;
  }
  return (
    <select
      className="portfolio-selector"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Select a portfolio…</option>
      {portfolios.map((p) => (
        <option key={p.portfolio_code} value={p.portfolio_code}>
          {p.portfolio_name} ({p.portfolio_code})
        </option>
      ))}
    </select>
  );
};

export default PortfolioSelector;
